import React, { Component } from "react";
import { connect } from "react-redux";
import {useParams} from "react-router-dom";
import {Button, Container} from "react-bootstrap";
import * as axios from "axios";
import QueryString from "qs";
import fileDownload from "js-file-download";

class Custom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      plan: JSON.parse(localStorage.getItem("plan")) || []
    };
  }
  componentDidMount() {
    let { id } = this.props.params;
    this.setState({id: id})
    console.log(this.props.params)
    axios.get(`https://fullmusculo.com/api/personal_routine?id=${id}`,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
        )
        .then((res) => {
          console.log(res);
          if (res.data.content) {
            this.setState({plan: res.data.content})
          }
        })
        .catch((err) => console.log(err));
  }
    downloadPlan() {
        axios.post(
                "https://fullmusculo.com/api/pdfdownload",
                {
                    data: this.state.plan,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                    responseType: "blob",
                }
            )
            .then((res) => {
                const blob = new Blob([res.data], {type: "application/pdf"});
                const objectUrl = window.URL.createObjectURL(blob);
                window.open(objectUrl);
                fileDownload(blob, "TuRutinaFullMusculo.pdf");
            })
            .catch((err) => console.log(err));
    }
  render() {
    return (
      <>
        <div>
            {this.state.plan.length > 0 ? <Button
                className="pdfprint"
                onClick={() => this.downloadPlan()}
                style={{width: "fit-content"}}
            >
                <i className="fas fa-file-pdf"></i> Descargar tu rutina
            </Button>: null}
            {this.state.plan.length <= 0 ?<><p style={{textAlign: 'center'}}>No hay una rutina creada. ingresa a la sección de <a href={"/ejercicios"}>Ejercicios</a> para crear tu rutina personalizada. </p></> : null}
          {this.state.plan.map((day,index) =>
              <table className={"personal_rutine"} key={`day-${day.id}`}>
                <thead>
                <tr className="title">
                  <th colSpan="8">Dia {day.id}</th>
                </tr>
                <tr>
                  <th></th>
                  <th>Ejercicio</th>
                  <th>N Series</th>
                  <th>Repeticiones</th>
                  <th>RPE/RIR</th>
                  <th>Carga (Kg)</th>
                  <th>Descanso</th>
                  <th>Notas</th>
                </tr>
                </thead>
                <tbody>
                {
                  day.items.map((item,index) =>
                    <tr key={`item-${index}`}>
                      <td className="index">{index + 1}</td>
                      <td style={{textAlign: "start",margin: ".5rem 0px"}}>
                        <div style={{display: "flex", margin: ".5rem 0px"}}>
                          <img src={(item.Recommend_Image === 1 ? item.Small_Img_1 : item.Small_Img_2)}
                          alt="ejercicio"
                          style={{width: "100px",padding: "0px 10px",
                              objectFit: "cover",height:"fit-content"}}/>
                          <div>
                            <b><a href={`https://fullmusculo.com/ejercicios/#/ejercicio/${item.Exercise_Id}`}>{item.Exercise_Name_Complete}</a></b>
                            <p style={{fontSize: "10px", marginBottom:"0px"}}><b>Músculo:</b> {item.Target_Muscle_Group}</p>
                            <p style={{fontSize: "10px", marginTop: "0px"}}><b>Implementos:</b> {item.Apparatus_Groups_Name}
                            </p>
                          </div>
                        </div>

                      </td>
                      <td className="sets">{item.sets}</td>
                      <td>{item.reps}</td>
                      <td className="rpe"></td>
                      <td className="carga"></td>
                      <td className="descanso"></td>
                      <td className="notas"></td>
                    </tr>
                  )
                }

                </tbody>
              </table>
          )}

        </div>
      </>
    );
  }
}
function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}
const mapStateToProps = state => ({
});
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(withParams(Custom));
